import React from 'react'
import demo_img from '../../../images/doctor-sm.png'
import './blog.css'
export default function BlogSingle() {
 return (

  <div className=''>
<div className="blog-item " 
 data-aos="fade-up"
>
  <p>
    <i className="bx bxs-quote-alt-left quote-icon-left"></i>
    Engaging in routine physical activity not only enhances fitness but also elevates mood and reduces the risk of chronic diseases, promoting overall health and vitality.<i className="bx bxs-quote-alt-right quote-icon-right"></i> <br></br><span><a href="#">Read Blog</a></span>
    
  </p>
  <img src={demo_img} className="blog-img"  alt="" />
  <h3>Saul Goodman</h3>
  <h4>Ceo &amp; Founder</h4>
</div>   
</div>   

 )
}
